interface GlobalNavigationConfig {
  start: string;
  book: string;
  rent: string;
  about: string;
  profile: string;
}

export const globalNavigationConfig: GlobalNavigationConfig = {
  start: import.meta.env.VITE_NAVIGATION_BOOK_URL || "http://localhost:3000",
  book: `${import.meta.env.VITE_NAVIGATION_BOOK_URL || "http://localhost:3000"}/booking`,
  rent: import.meta.env.VITE_NAVIGATION_RENT_URL || "http://localhost:3001",
  about: `${import.meta.env.VITE_NAVIGATION_BOOK_URL || "http://localhost:3000"}/about`,
  profile:
    import.meta.env.VITE_NAVIGATION_PROFILE_URL || "http://localhost:3002",
};

export const isCurrentUrl = (url: string): boolean => {
  try {
    const targetUrl = new URL(url);
    const currentUrl = window.location;

    // Hostname, Port müssen übereinstimmen
    const hostnameMatches = targetUrl.hostname === currentUrl.hostname;
    const portMatches = targetUrl.port === currentUrl.port;

    // Bei localhost vergleichen wir Hostname, Port
    if (targetUrl.hostname === "localhost") {
      return hostnameMatches && portMatches;
    }

    // Bei anderen Domains vergleichen wir Hostname
    return hostnameMatches;
  } catch {
    return false;
  }
};
